import React, { useCallback, useRef, useState } from "react";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  InfoWindow,
} from "@react-google-maps/api";
import { Box } from "@mui/material";
import MapPinIcon from "src/assets/svg-icons/map_pin.svg";
import { useTranslation } from "react-i18next";

interface IProps {
  list?: any[];
}

const containerStyle = { height: "100vh", width: "100%" };

const AllMap: React.FC<IProps> = ({ list }) => {
  const { i18n } = useTranslation();
  const [activeOperator, setActiveOperator] = useState<any | null>(null);
  const [open, setOpen] = useState(false);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyBjGZRBq1seDBmbq62CMyV2VkpRrOwNh_Q",
  });

  const mapRef = useRef<google.maps.Map | null>(null);

  const onLoad = useCallback(
    (map: google.maps.Map) => {
      mapRef.current = map;
      if (!list || list.length === 0) return;

      const bounds = new window.google.maps.LatLngBounds();
      list?.forEach((item) => {
        const lat = item.locationLatitude;
        const lng = item.locationLongitude;

        const isValidCoord =
          typeof lat === "number" &&
          typeof lng === "number" &&
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat >= -90 &&
          lat <= 90 &&
          lng >= -180 &&
          lng <= 180;

        if (isValidCoord) {
          bounds.extend({
            lat: item.locationLatitude,
            lng: item.locationLongitude,
          });
        }
      });

      map.fitBounds(bounds); // auto-zoom & center
    },
    [list],
  );

  const onUnmount = useCallback(() => {
    mapRef.current = null;
  }, []);

  const handleOpen = (id: string) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log({ list });

  return isLoaded ? (
    <Box borderRadius={2} overflow="hidden" height={"100%"}>
      <GoogleMap
        onClick={() => setActiveOperator(null)}
        mapContainerStyle={containerStyle}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          mapTypeControl: true,
          streetViewControl: false,
          fullscreenControl: false,
        }}
      >
        {list?.map((location) => {
          const lat = location.locationLatitude;
          const lng = location.locationLongitude;

          const isValidCoord =
            typeof lat === "number" &&
            typeof lng === "number" &&
            !isNaN(lat) &&
            !isNaN(lng) &&
            lat >= -90 &&
            lat <= 90 &&
            lng >= -180 &&
            lng <= 180;

          if (!isValidCoord) return null;

          return (
            <>
              <Marker
                key={location.id}
                position={{ lat, lng }}
                label={{
                  text: location.nameEn,
                  color: "#464646",
                  fontSize: "12px",
                  fontWeight: "500",
                  className: "kafd-location-marker-label",
                }}
                // onClick={() => setActiveOperator(operator)}
                options={{
                  icon: {
                    url: MapPinIcon,
                    scaledSize: new window.google.maps.Size(35, 35), // Adjust size as needed
                    labelOrigin: new window.google.maps.Point(15, 46),
                    // origin: new window.google.maps.Point(0, 0),
                    // anchor: new window.google.maps.Point(25, 50),
                  },
                }}
              />
              {/* {activeOperator && activeOperator.id === operator.id && (
                <InfoWindow
                  position={{
                    lat: lat,
                    lng: lng,
                  }}
                  onCloseClick={() => setActiveOperator(null)}
                >
                  <Box
                    border={"1px solid #242424"}
                    padding={1}
                    display={"flex"}
                    flexDirection={"column"}
                    gap={0.5}
                    borderRadius={"4px"}
                    bgcolor={"#000"}
                    minWidth={"164px"}
                    maxWidth={"164px"}
                  >
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                      <PersonIcon fontSize="small" />
                      <Typography fontSize={"12px"}>
                        {operator.operatorName}
                      </Typography>
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                      <LocalPhoneIcon fontSize="small" />
                      <Typography fontSize={"12px"}>
                        {operator.operatorPhoneNumber ?? "_"}
                      </Typography>
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                      <LocationOnIcon fontSize="small" />
                      <Typography fontSize={"12px"}>
                        {operator.locationName}
                      </Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"flex-end"}>
                      <Button
                        size="small"
                        variant="text"
                        onClick={() => handleOpen(operator.id)}
                      >
                        Track
                      </Button>
                    </Stack>
                  </Box>
                </InfoWindow>
              )} */}
            </>
          );
        })}
      </GoogleMap>
    </Box>
  ) : null;
};

export default AllMap;
